import { makeAutoObservable } from 'mobx'
import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { type CreditUsage } from 'entities/Analytics/model/CreditUsage'
import { type Message } from 'entities/Message/model/Message'
import { CreditUsageMessageModalContent } from '../ui/CreditUsageMessageModalContent'

export class CreditUsageMessageModalStore {
  private _idModal = nanoid()

  constructor(private _creditUsage: CreditUsage, private _message: Message) {
    makeAutoObservable(this)
  }

  openModal = () => {
    modalStore.addModal({
      id: this._idModal,
      title: 'See message',
      showCloseButton: false,
      showCloseIcon: true,
      width: 480,
      ModalContent: CreditUsageMessageModalContent,
      ModalContentProps: {
        store: this,
      },
      onClose: this.closeModal,
      paddingContent: '0 24px 16px 24px',
    })
  }

  closeModal = () => {
    modalStore.removeModal(this._idModal)
  }

  get message() {
    return this._message
  }

  get creditUsage() {
    return this._creditUsage
  }
}
